var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendChatButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15513",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15513",
    transform: "translate(-9750 -22272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9520",
    "data-name": "\\u9577\\u65B9\\u5F62 9520",
    width: 78,
    height: 78,
    transform: "translate(9750 22272)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M62.776,28.628a10.032,10.032,0,0,0-4.012-4.012h0L15.556,3.012A9.4,9.4,0,0,0,3.211,7.024,7.681,7.681,0,0,0,2.9,14.74L9.383,29.554H37.468a2.916,2.916,0,0,1,3.086,3.086,2.916,2.916,0,0,1-3.086,3.086H9.383L2.9,50.541A9.375,9.375,0,0,0,7.531,62.886a15.491,15.491,0,0,0,3.7.617,8.543,8.543,0,0,0,4.012-.926l43.208-21.6A9.434,9.434,0,0,0,62.776,28.628Z",
    transform: "translate(9758.326 22278.496)",
    fill: "#8b6fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatButton);
export default __webpack_public_path__ + "static/media/sendChatButton.54742371d0198c9f724625c4176cb407.svg";
export { ForwardRef as ReactComponent };